import React from 'react';
import { Link } from 'react-router-dom';
import { Stack } from '@mui/material';

const Navbar = () => (
<header>
    <div className="avez_navbar">
        <div className="avez_logo">
        <Link className="logo" to="/">
      <h1>FIT <span style={{ color: 'red' }}>CLUB</span></h1>
    </Link>
        </div>
        <div className="avez_nav_list">
            <ul>
                <li><Link to="/" className="navGym" style={{ textDecoration: 'none', color: '#fff', fontSize: '1rem' }}>Home</Link></li>
                <li><a href="#exercises" className="navGym SmallNone" style={{ textDecoration: 'none', color: '#fff', fontSize: '1rem' }}>Exercises</a></li>
            </ul>
        </div>
    </div>
</header>
);

export default Navbar;
